import BaseDevice from '../base.js'
const INPUT_HEIGHT = 60;

const normalizeColorHex = (value) => {
   if (!value) {
      return "";
   }
   if (COLORS_RGB[value]) {
      return COLORS_RGB[value];
   }
   if (typeof value === 'string') {
      return value.replace('#', '').slice(0, 6);
   }
   return "";
};

export default class DeviceImage extends BaseDevice {

   // Returns ordered phase labels array (without N/PE) based on device.texts values
   static getOrderedPhaseLabels(device) {
      try {
         const values = device && device.texts ? Object.values(device.texts) : [];
         // Detect which notation is used for phases
         let group;
         if (values.includes('L1')) group = ['L1', 'L2', 'L3'];
         else if (values.includes('A')) group = ['A', 'B', 'C'];
         else if (values.includes('А')) group = ['А', 'Б', 'В']; // Cyrillic
         else {
            // Fallback: take first distinct labels excluding N/PE from provided values
            group = values.filter(v => v && v.toUpperCase() !== 'N' && v.toUpperCase() !== 'PE');
         }
         // Trim to required phase count
         return group.slice(0, device.phaseCount || 3);
      } catch (e) {
         console.warn('Phase label ordering fallback', e);
         return ['L1', 'L2', 'L3'].slice(0, device.phaseCount || 3);
      }
   }

   static render = (device, scale = 1) => {
      const res = this.getDevice(device, scale, false, true);
      return res
   }

   static getPorts(device, position) {
      // Device info removed


      if (position !== 'bottom') {
         return ""; // we need to render just for one position
      }

      device.bottomPorts = device.topPorts = device.phaseCount + 2;

      const height = this.getHeight(device);
      // const width = this.getWidth(device);
      // const baseWidth = STORAGE.getSetting('baseWidth', BASE_WIDTH)
      const portsCount = device.phaseCount + 2; // a, b, c, n, pe

      let [screwWidth, spaceX] = [30, 4]


      const y = this.getPortY(device, position, screwWidth, height) + (device.twistedDeg == 'bottom' ? -5 : 15);

      let res = '';
      let transform;
      let x;

      if (device.twistedDeg == 'bottom') {
         position = 'top'; // connect wires to the top when input is on the bottom
      }
      let wireDirection = 'bottom';

      switch (device.twistedDeg) {
         case '-90':
            wireDirection = 'right';
            break;
         case '90':
            wireDirection = 'left';
            break
         case 'bottom':
            wireDirection = 'top';
            break
         default:
            wireDirection = 'bottom';
            break
      }
      // device.texts


      const orderedPhaseLabels = this.getOrderedPhaseLabels(device);
      const colorKeys = ['L1', 'L2', 'L3', 'L4']; // handle up to 4 phases if needed
      for (var i = 0; i < portsCount; i++) {
         x = spaceX + i * screwWidth + 2 * spaceX * i;
         let textX = x + 5;
         const textY = y - (device.twistedDeg == 'bottom' ? -45 : 10);
         let text;
         let colorName;
         let isGround = false;
         if (i < device.phaseCount) {
            const key = colorKeys[i] || `L${i + 1}`;
            text = orderedPhaseLabels[i] || key;
            colorName = device.colors && key in device.colors ? device.colors[key] : 'grey';
         } else if (portsCount - i == 2) {
            text = 'N';
            textX += 3;
            colorName = (device.colors && device.colors.N) || 'blue';
         } else if (portsCount - i == 1) {
            text = 'PE';
            colorName = (device.colors && device.colors.PE) || 'yellow';
            isGround = true;
         } else {
            colorName = 'grey';
         }
         let image;
         if (isGround) {
            image = PARTS[`screw_pe`];
         } else {
            const screwAssetKey = colorName ? `screw_${colorName}` : '';
            image = (screwAssetKey && PARTS[screwAssetKey]) ? PARTS[screwAssetKey] : PARTS.screw_grey;
         }

         // if (device.twisted || true) {
         //    transform = `transform="rotate(-90, ${textX}, ${textY})"`
         //    // num = ports - i - 1;
         //    // text = device.phasesDetails[ports - i - 1].text;
         // } else {
         //    // text = device.phasesDetails[i].text;
         // }
         // switch (position) {
         //    case 'top'
         // }


         const dataId = `${text}_${device.id}`
         const dataColor = normalizeColorHex(colorName);
         res += `<image data-wire-direction="${wireDirection}" data-color="${dataColor}" class="screw" data-id="${dataId}" width="${screwWidth}" height="${screwWidth}" x="${x}" y="${y}" data-position="${position}" data-id="${this.getPortId(device, position, i)}" href="${image}"/>`
         res += `<text data-i=${i} data-text="${text}" x="${textX}" y="${textY}" class="txtBold${device.id} conText" dominant-baseline="middle" stroke='${this.isBlack(device) ? 'white' : 'black'}' text-anchor="right" ${transform}>${text}</text>`;
      }

      res += `<style>
      .txtBold${device.id} {
         font: bold 18px sans-serif;
         fill: ${this.isBlack(device) ? "white" : "black"};
      }
    </style>`
      return res;
   }
   static getHeight = (device) => {
      return INPUT_HEIGHT;
   }

   static getTextPadding = (device, DEFAULT_PADDING) => { // see generic device
      return this.getHeight(device) / 2;
   }


}

// TEMPORARY TEST (remove after verification)
if (typeof window !== 'undefined') {
   const testDevice = {
      id: 'test',
      phaseCount: 3,
      texts: { phase1: 'C', phase2: 'A', phase3: 'B', neutral: 'N', ground: 'PE' },
      colors: { L1: 'brown', L2: 'black', L3: 'grey', N: 'blue', PE: 'yellow' },
      twistedDeg: 0
   };
   try {
      const ordered = DeviceImage.getOrderedPhaseLabels(testDevice);
      // Input ordering test removed
   } catch (e) {
      console.warn('Ordering test failed', e);
   }
}
